import React from 'react';
import Head from 'next/head';

/*
The interface for this component is the same as a <picture>, but only one of the
media queries on the <source>'s should be true and they should exhaustively cover all screen sizes. 
Visually it will act the same as a picture, but if @param preload is true it injects preload 
link tags into the page header to make the appropriate image load with priority. Use for above-the-fold images
*/

const PreloadablePicture = (props) => {
  const { children, preload, ...otherProps } = props;
  return (
    <>
      {preload &&
        <Head>
          {React.Children.map(children,
            (child) => {
              if (child.type === 'source') {
                const { srcSet, media } = child.props;
                return <link rel="preload" as="image" href={srcSet} media={media || ''} key={srcSet} />
              }
              return undefined;
            })}
        </Head>
      }
      <picture {...otherProps}>
        {children}
      </picture>
    </>
  )
}

export default PreloadablePicture;